import {Dispatch} from "redux";
import {ActionType} from "../actionTypes/actionTypes";
import {IDispatch} from "../models";
import {EasterEggDto} from "../../dtos/flyer";

export const changeEasterEggDataDispatcher = (easterEggData: EasterEggDto) => {
    return async (dispatch: Dispatch<IDispatch<ActionType>>) => {
        dispatch({
            type: ActionType.CHANGE_EASTER_EGG_DATA,
            payload: easterEggData
        });
    };
};